import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';

// Ported 1:1 from the prototype `login.html` + `.auth*` styles (two-column sign-in).
export const styles = {
  auth: {
    kAzted: "xg6iff7",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kWkggS: "x16vpd03",
    $$css: true
  },
  main: {
    kVAEAm: "x1n2onr6",
    kzqmXN: "xh8yej3",
    k1xSpc: "x78zum5",
    kjj79g: "xl56j7k",
    kmVPX3: "xum75ri",
    $$css: true
  },
  glow: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xwa60dl",
    kbCHJM: "x1nrll8i",
    k3aq6I: "x11lhmoz",
    kzqmXN: "x11i3ho8",
    kZKoxP: "x1d9x2de",
    kaIpWk: "xoy5co8",
    kKwaWg: "xaoo0j4",
    kfzvcC: "x47corl",
    $$css: true
  },
  card: {
    kVAEAm: "x1n2onr6",
    kzqmXN: "xh8yej3",
    ks0D6T: "xq2pcee",
    kB7OPa: "x9f619",
    k8WAf4: "xdl74pg",
    kg3NbH: "x1tcxzho",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x7tdnnd",
    kGVxlE: "xkqgayn",
    $$css: true
  },
  brand: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    k1K539: "xrn58dq",
    $$css: true
  },
  brandMark: {
    kzqmXN: "x1td3qas",
    kZKoxP: "x10w6t97",
    kaIpWk: "xhpnuu7",
    kmuXW: "x2lah0s",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kMwMTN: "x1m3rtoy",
    kKwaWg: "x1w4ef1l",
    $$css: true
  },
  brandName: {
    kMv6JI: "xpc6l4x",
    k63SB2: "xtpl1r7",
    kGuDYH: "x19d36u7",
    kb6lSQ: "x16q24ku",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  brandNameLight: {
    kMwMTN: "xbijz3y",
    $$css: true
  },
  brandAccent: {
    kMwMTN: "x1459q0w",
    $$css: true
  },
  h1: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x1pvqxga",
    k63SB2: "xomqrzn",
    k1K539: "x1vvky8i",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  lead: {
    kMwMTN: "xdxw5r1",
    k1K539: "xrn58dq",
    kGuDYH: "x2ouz8m",
    $$css: true
  },
  form: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1bof9c1",
    $$css: true
  },
  footLink: {
    keoZOQ: "xv1leuy",
    kGuDYH: "x4z9k3i",
    kMwMTN: "xdxw5r1",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  link: {
    kMwMTN: "x1459q0w",
    k63SB2: "xssbmp7",
    kybGjl: "x1hl2dhg",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  error: {
    kogj98: "x1ghz6dp",
    kMwMTN: "x2wi9gy",
    kWkggS: "x8qqj1s",
    kaIpWk: "xxltkoq",
    kmVPX3: "x181f5ma",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xssbmp7",
    $$css: true
  },
  langSwitch: {
    keoZOQ: "xv1leuy",
    k1xSpc: "x78zum5",
    kjj79g: "xl56j7k",
    $$css: true
  },
  qrWrap: {
    k1xSpc: "x78zum5",
    kjj79g: "xl56j7k",
    kmVPX3: "xd1rx2h",
    k1K539: "x1hftx76",
    kWkggS: "x13uruat",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    $$css: true
  },
  manualKey: {
    kMv6JI: "x1gs96k",
    kGuDYH: "xfifm61",
    kMwMTN: "x1em627c",
    k9WMMc: "x2b8uid",
    kTgw9: "x1yn0g08",
    k1K539: "x1hftx76",
    $$css: true
  },
  codeInput: {
    k9WMMc: "x2b8uid",
    kb6lSQ: "xtc2khw",
    kMv6JI: "x1gs96k",
    $$css: true
  },
  notice: {
    kMwMTN: "x5ehtoo",
    kGuDYH: "x2ouz8m",
    k1K539: "x1cg34oi",
    kLWn49: "x1evy7pa",
    $$css: true
  }
};